import { GetComponentStyleFunc } from './types';

export const muiSlider: GetComponentStyleFunc<'MuiSlider'> = () => {
  return {};
};
